import React from 'react'
import Menu from '../menu'
import NavLogo from '../nav-logo'
import SignOutButton from '../sign-out-button'

export default () => {
  return (
    <div className="navigation">
      <div className="navigation__track">
        <div className="navigation__item">
          <NavLogo />
        </div>
        <div className="navigation__item">
          <Menu />
        </div>
        <div className="navigation__item">
          <SignOutButton />
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/desktop/components/navigation/index.js